export interface FilterMenu {
    filterId: string;
    title: string;
    values: string[];
    expanded: boolean;
    filterParameter: string | null;
}

export interface ActiveFilter {
    filterId: string;
    value: string;
}

export enum SortDirectionType {
    Ascending,
    Descending
}

export interface SortContext {
    sortType: SortTypes;
    sortDirection: SortDirectionType;
}

export enum RequestState {
    Default,
    Sending,
    Sent,
    FailedToSend
}

export enum RegulationFiterType {
    Compliant = "Compliant",
    PossiblyCompliant = "PossiblyComplaint"
}

export interface Column {
    name: string;
    columnId: string;
    width: number;
}

export interface SharedMaterialsTableColumns {
    checkbox: Column;
    photo: Column;
    supplierName: Column;
    materialName: Column;
    category: Column;
    fmd: Column;
   
}

export enum ColumnId {
    Checkbox = "Checkbox",
    Photo = "Photo",
    SupplierName = "SupplierName",
    Name = "Name",
    Category = "Category",
    Fmd = "Fmd",
    Sds = "Sds"
}

export enum SortTypes {
    SupplierName,
    PassportName,
    Category,
    Featured
}

export enum BrowserSearchMode {
    Materials,
    Companies
}
